// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class ListCollectionsCarousel extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector(
      '[data-el="list-collections.slides"]'
    )
    this.slideEls = this.querySelectorAll(
      '[data-el="list-collections.slide"]'
    )
    this.dotEls = this.querySelectorAll(
      '[data-el="list-collections.dot"]'
    )

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()

  }

  initialiseCarousel () {
    return new KeenSlider(this.slidesEl, {
      duration: 1000,
      centered: false,
      loop: false,
      mode: 'free',
      slides: '.car-Carousel_Slide',
      slidesPerView: 1.6,
      spacing: 10,
      breakpoints: {
        '(min-width: 768px)': {
          loop: true,
          mode: 'snap',
          slidesPerView: 2.4,
        },
        '(min-width: 900px)': {
          controls: false,
          slidesPerView: 2,
        },
      },
      slideChanged: instance => {
        this.dotEls.forEach(dot => {
          dot.setAttribute(
            'aria-current',
            parseInt(dot.dataset.slide) === instance.details().relativeSlide
          )
        })
      },
    })
  }
}

customElements.define('list-collections', ListCollectionsCarousel)
